import { apiEndpoint } from "../utils/env";

async function fetchWithAuth(url, token, options = {}) {
  const headers = { "Content-Type": "application/json", ...options.headers };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(url, { ...options, headers });
  const txt = await res.text();
  let json = null;
  try { json = txt ? JSON.parse(txt) : null; } catch { json = txt; }
  if (!res.ok) {
    const msg = json?.message ?? (typeof json === "string" ? json : res.statusText);
    throw Object.assign(new Error(msg || `Request failed: ${res.status}`), { status: res.status });
  }
  return json;
}

export async function getUserAiSettings(token) {
  return fetchWithAuth(apiEndpoint("/api/AiSettings/user"), token, { method: "GET" });
}

export async function saveUserAiSettings(token, { useAi, apiKey, clearKey, model }) {
  return fetchWithAuth(apiEndpoint("/api/AiSettings/user"), token, {
    method: "PUT",
    body: JSON.stringify({ useAi, apiKey: apiKey ?? null, clearKey: clearKey ?? false, model: model ?? null }),
  });
}

export async function getOrgAiSettings(token) {
  return fetchWithAuth(apiEndpoint("/api/AiSettings/org"), token, { method: "GET" });
}

export async function saveOrgAiSettings(token, { apiKey, clearKey, model, endpoint }) {
  return fetchWithAuth(apiEndpoint("/api/AiSettings/org"), token, {
    method: "PUT",
    body: JSON.stringify({
      apiKey: apiKey ?? null,
      clearKey: clearKey ?? false,
      model: model ?? null,
      endpoint: endpoint ?? null,
    }),
  });
}

export async function testOrgAiSettings(token, { apiKey, model, endpoint }) {
  return fetchWithAuth(apiEndpoint("/api/AiSettings/org/test"), token, {
    method: "POST",
    body: JSON.stringify({
      apiKey: apiKey ?? null,
      model: model ?? null,
      endpoint: endpoint ?? null,
    }),
  });
}
